import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ee9bfe2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings-form form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-x" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "heading h1 form-title" }, " Settings ")
], -1))
const _hoisted_3 = { class: "grid-x" }
const _hoisted_4 = { class: "cell small-12 xxlarge-8" }
const _hoisted_5 = { class: "form-section" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section-title text-w-bold" }, " MY PROFILE ", -1))
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "body-text-lg text-w-bold" }, " Full Name ", -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "body-text-lg text-w-bold" }, " Corporate Email ", -1))
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "body-text-lg text-w-bold" }, " Job Title ", -1))
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "body-text-lg text-w-bold" }, " Company ", -1))
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "input-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "body-text-lg text-w-bold" }, " Direct Phone Number ", -1))
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "input-group" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "body-text-lg text-w-bold" }, " Meetings Link ", -1))
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "form-section" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section-title text-w-bold" }, " SECURITY AND PRIVACY ", -1))
const _hoisted_27 = { class: "button-group vertical" }
const _hoisted_28 = { class: "grid-x" }
const _hoisted_29 = { class: "cell small-12 large-6" }
const _hoisted_30 = { class: "grid-x" }
const _hoisted_31 = { class: "cell small-12 large-6" }
const _hoisted_32 = { class: "form-section" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section-title text-w-bold" }, " NOTIFICATIONS ", -1))
const _hoisted_34 = { class: "input-group grid-x" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell auto" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "body-text-lg text-w-bold" }, " Receive Email Notifications ")
], -1))
const _hoisted_36 = { class: "cell auto text-align-right" }
const _hoisted_37 = { class: "button-container grid-x align-center" }
const _hoisted_38 = { class: "cell small-12 large-4" }

import { ref, onMounted } from 'vue'
import { NCard, NForm, NFormItem, NInput, NSwitch, NButton, NIcon, FormInst } from 'naive-ui';
import { ExternalLinkAlt, Edit as EditIconFa } from '@vicons/fa'
import { settingsFormRules } from "@/ts/formValidationRules";
import { onlyAllowNumberValidator } from "@/ts/validation";
import { editIcon } from "@/assets/utils/icons";

import { useAuthMeStore } from "@/stores/auth/me.store";
import { useUpdateClientStore } from "@/stores/client/profile-settings.store";
import { UserServerData } from "@/ts/interfaces/requests/user";

import NewPasswordForm from "@/components/NewPasswordForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsForm',
  emits: [ 'submitAction' ],
  setup(__props, { emit: __emit }) {

const emit = __emit

const authMeStore = useAuthMeStore()
const updateClientStore = useUpdateClientStore()

const formRef = ref<FormInst | null>(null)
const showPasswordUpdateForm = ref<boolean>(false)

const formData = ref<UserServerData>({
  name: '',
  email: '',
  job_title: '',
  company: '',
  phone_number: '',
  meetings_link: '',
  email_notifications: true
})

const submit = () => {
  formRef.value?.validate((errors) => {
    if (!errors) {
      updateClientStore.edit(formData.value)
    }
  })
}

onMounted(async () => {
  await authMeStore.getUser()
  formData.value = authMeStore.user
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(NCard), {
      size: "large",
      bordered: false
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(NForm), {
              ref_key: "formRef",
              ref: formRef,
              model: formData.value,
              rules: _unref(settingsFormRules)
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_unref(NFormItem), {
                      label: "Full name",
                      path: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInput), {
                          value: formData.value.name,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                          size: "medium",
                          round: "",
                          placeholder: "Type the role title here",
                          class: "form-input"
                        }, {
                          suffix: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "input-icon",
                              innerHTML: _unref(editIcon)
                            }, null, 8, _hoisted_9)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_unref(NFormItem), {
                      label: "Corporate Email",
                      path: "email"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInput), {
                          value: formData.value.email,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event)),
                          size: "medium",
                          round: "",
                          placeholder: "YourCorporate@email.com",
                          class: "form-input",
                          onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, {
                          suffix: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "input-icon",
                              innerHTML: _unref(editIcon)
                            }, null, 8, _hoisted_12)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_unref(NFormItem), {
                      label: "Job Title",
                      path: "job_title"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInput), {
                          value: formData.value.job_title,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.job_title) = $event)),
                          size: "medium",
                          round: "",
                          placeholder: "Type here your job title",
                          class: "form-input",
                          onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, {
                          suffix: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "input-icon",
                              innerHTML: _unref(editIcon)
                            }, null, 8, _hoisted_15)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(_unref(NFormItem), {
                      label: "Company",
                      path: "company"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInput), {
                          value: formData.value.company,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.company) = $event)),
                          size: "medium",
                          round: "",
                          placeholder: "Type your company",
                          class: "form-input",
                          onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, {
                          suffix: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "input-icon",
                              innerHTML: _unref(editIcon)
                            }, null, 8, _hoisted_18)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode(_unref(NFormItem), {
                      label: "Phone Number",
                      path: "phone_number"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInput), {
                          value: formData.value.phone_number,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.phone_number) = $event)),
                          size: "medium",
                          round: "",
                          placeholder: "Type your phone number here",
                          class: "form-input",
                          type: "text",
                          "allow-input": _unref(onlyAllowNumberValidator)
                        }, {
                          suffix: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "input-icon",
                              innerHTML: _unref(editIcon)
                            }, null, 8, _hoisted_21)
                          ]),
                          _: 1
                        }, 8, ["value", "allow-input"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode(_unref(NFormItem), {
                      label: "Company",
                      path: "meetings_link"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInput), {
                          value: formData.value.meetings_link,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.meetings_link) = $event)),
                          size: "medium",
                          round: "",
                          placeholder: "Type your company",
                          class: "form-input",
                          onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, {
                          suffix: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "input-icon",
                              innerHTML: _unref(editIcon)
                            }, null, 8, _hoisted_24)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _withDirectives(_createVNode(_unref(NCard), {
                    title: "UPDATE PASSWORD",
                    class: "new-password-form",
                    closable: "",
                    onClose: _cache[10] || (_cache[10] = ($event: any) => (showPasswordUpdateForm.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(NewPasswordForm, { "form-data": _ctx.passwordFormData }, null, 8, ["form-data"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, showPasswordUpdateForm.value]
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _withDirectives(_createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_unref(NButton), {
                          size: "large",
                          type: "primary",
                          focusable: true,
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (showPasswordUpdateForm.value = true))
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_unref(EditIconFa))
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" UPDATE PASSWORD ")
                          ]),
                          _: 1
                        })
                      ])
                    ], 512), [
                      [_vShow, !showPasswordUpdateForm.value]
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_unref(NButton), {
                          size: "large",
                          type: "primary",
                          focusable: true
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_unref(NIcon), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ExternalLinkAlt))
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" PRIVACY POLICY ")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_unref(NSwitch), {
                        value: formData.value.email_notifications,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.email_notifications) = $event))
                      }, null, 8, ["value"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createVNode(_unref(NButton), {
          onClick: _withModifiers(submit, ["prevent"]),
          class: "new-project-button",
          size: "large",
          tabindex: "0"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" SAVE ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})